import React, { useEffect, useState } from 'react';
import { Check, Gift, ShoppingCart, Users, Download, ShieldCheck, ChevronDown, ChevronUp, Star, ArrowRight, UtensilsCrossed, BarChart3 } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { ExitIntentPopup } from '../ui/ExitIntentPopup';
function CountdownTimer() {
  const [seconds, setSeconds] = useState(15 * 60);
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(s => s <= 1 ? 15 * 60 : s - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const mins = String(Math.floor(seconds / 60)).padStart(2, '0');
  const secs = String(seconds % 60).padStart(2, '0');
  return <div className="bg-red-600 text-white rounded-xl p-4 mb-6 text-center" data-id="element-150">
      <p className="text-sm font-semibold uppercase tracking-wide mb-2 opacity-90" data-id="element-151">
        Últimos minutos para que el descuento esté activo
      </p>
      <div className="flex items-center justify-center gap-2" data-id="element-152">
        <div className="bg-red-800 rounded-lg px-4 py-2 min-w-[56px] text-center" data-id="element-153">
          <span className="text-3xl font-extrabold tabular-nums" data-id="element-154">{mins}</span>
          <p className="text-xs opacity-75 mt-0.5" data-id="element-155">MIN</p>
        </div>
        <span className="text-3xl font-extrabold" data-id="element-156">:</span>
        <div className="bg-red-800 rounded-lg px-4 py-2 min-w-[56px] text-center" data-id="element-157">
          <span className="text-3xl font-extrabold tabular-nums" data-id="element-158">{secs}</span>
          <p className="text-xs opacity-75 mt-0.5" data-id="element-159">SEG</p>
        </div>
      </div>
    </div>;
}
const bonusSummary = [{
  title: 'El Ritual 7×1 (Starter Kit)',
  image: 'https://cdn.magicpatterns.com/uploads/qojd7ppLZJzCA1AcsA5WFN/El-Ritual-71-Starter-Kit.png',
  value: '$890',
  description: 'Todo lo que necesitás para arrancar hoy: guía paso a paso, checklist, tracker de 7 días y tarjeta de heladera con tus 3 reglas diarias.',
  quote: 'Si es fácil, se sostiene. Este kit existe para que no haya excusa el Día 1.'
}, {
  title: 'Guía de Señales Silenciosas',
  image: 'https://cdn.magicpatterns.com/uploads/5FUU7LAuS9NjgnP1JSwzAp/Tu-cuerpo-avisa-en-silencio-antes-de-gritar.png',
  value: '$590',
  description: 'Aprendé a leer las 3 ventanas del día (mañana, post-comida, noche) para saber si lo que sentís es una señal de alerta o solo ruido. Incluye semáforo visual y guion para hablar con tu médico.',
  quote: 'Cuando escuchás temprano, evitás el susto tarde.'
}, {
  title: 'Kit Anti-Picos Express',
  image: 'https://cdn.magicpatterns.com/uploads/mGWupp33G59swixDCTAQmw/Kit-Anti-Picos-Express-Post-Comida-en-10-Min.png',
  value: '$410',
  description: 'Un protocolo de 10 minutos para después de una comida pesada. Tres versiones: casa, trabajo y asado. Sin gimnasio, sin pastillas, sin irse de la mesa.',
  quote: 'No cambies tu comida hoy. Cambiá lo que hacés después.'
}];
const BASE_PRICE = 290;
const BUMP1_PRICE = 397;
const BUMP2_PRICE = 397;
function buildCartUrl(bump1: boolean, bump2: boolean) {
  if (bump1 && bump2) {
    return 'https://resetdiario.com/cart/53248593723756:1';
  }
  if (bump1) {
    return 'https://resetdiario.com/cart/53248592937324:1';
  }
  if (bump2) {
    return 'https://resetdiario.com/cart/53248593985900:1';
  }
  return 'https://www.resetdiario.com/cart/53153601519980:1';
}
export function OfferSection() {
  const [expandedBonus, setExpandedBonus] = useState<number | null>(null);
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const toggleBonus = (idx: number) => {
    setExpandedBonus(expandedBonus === idx ? null : idx);
  };
  const totalPrice = BASE_PRICE + (bump1 ? BUMP1_PRICE : 0) + (bump2 ? BUMP2_PRICE : 0);
  const cartUrl = buildCartUrl(bump1, bump2);
  const originalProtocol = 580;
  const originalBonuses = 1890;
  const originalBump1 = 1500;
  const originalBump2 = 1500;
  const totalOriginal = originalProtocol + originalBonuses + (bump1 ? originalBump1 : 0) + (bump2 ? originalBump2 : 0);
  const handleCheckoutClick = () => {
    if (!bump1 && !bump2) {
      // No bumps selected -> show exit intent popup
      setShowPopup(true);
    } else {
      // Bumps selected -> proceed normally
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart', {
          value: totalPrice,
          currency: 'UYU',
          content_name: 'El Protocolo de Limpieza Glicémica + Extras',
          content_type: 'product'
        });
      }
      window.location.href = cartUrl;
    }
  };
  return <section id="offer" className="py-16 px-4 bg-emerald-50" data-id="element-160">
      <style data-id="element-161">{`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        .bump-shimmer {
          position: relative;
          overflow: hidden;
        }
        .bump-shimmer::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            90deg,
            transparent 0%,
            rgba(255,255,255,0.08) 40%,
            rgba(255,255,255,0.15) 50%,
            rgba(255,255,255,0.08) 60%,
            transparent 100%
          );
          background-size: 200% 100%;
          animation: shimmer 3s ease-in-out infinite;
          pointer-events: none;
          border-radius: inherit;
        }
      `}</style>

      <div className="max-w-5xl mx-auto" data-id="element-162">
        <div className="text-center mb-10" data-id="element-163">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-164">
            Lo Que Recibe Hoy
          </h2>
          <p className="text-xl text-gray-600" data-id="element-165">
            El Protocolo Completo de Limpieza Glicémica de 7 Días
          </p>
        </div>

        <Card variant="highlight" className="max-w-3xl mx-auto relative" data-id="element-166">
          <div className="absolute top-0 right-0 bg-red-600 text-white px-4 py-1 rounded-bl-lg font-bold text-sm uppercase" data-id="element-167">
            50% Descuento
          </div>

          <div className="p-8 md:p-12" data-id="element-168">
            {/* Product */}
            <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-169">
              <div className="w-full md:w-1/3" data-id="element-170">
                <img src="https://cdn.magicpatterns.com/uploads/swco9uh88fgzGaxD6EYQFz/Mockup.png" alt="Pack Completo" className="w-full rounded-lg shadow-md" data-id="element-171" />
              </div>
              <div className="w-full md:w-2/3" data-id="element-172">
                <h3 className="text-2xl font-bold text-emerald-800 mb-4" data-id="element-173">
                  El Protocolo de Limpieza Glicémica
                </h3>
                <ul className="space-y-3 mb-6" data-id="element-174">
                  <li className="flex items-start" data-id="element-175">
                    <Check className="h-5 w-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-176" />
                    <span className="text-gray-700" data-id="element-177">
                      <strong data-id="element-178">La Guía de las 7 Hierbas Maestras</strong> (valor
                      $1.200)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-179">
                    <Check className="h-5 w-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-180" />
                    <span className="text-gray-700" data-id="element-181">
                      <strong data-id="element-182">El Truco del Post-Asado</strong> (valor $500)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-183">
                    <Check className="h-5 w-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-184" />
                    <span className="text-gray-700" data-id="element-185">
                      <strong data-id="element-186">La Técnica del Movimiento Invisible</strong>{' '}
                      (valor $400)
                    </span>
                  </li>
                </ul>
                <div className="bg-emerald-100 p-4 rounded-lg flex items-center gap-3" data-id="element-187">
                  <Gift className="h-6 w-6 text-emerald-700" data-id="element-188" />
                  <p className="text-sm text-emerald-800 font-medium" data-id="element-189">
                    Incluye acceso de por vida y actualizaciones futuras gratis.
                  </p>
                </div>
              </div>
            </div>

            {/* Bonuses with expandable details */}
            <div className="border-t border-gray-200 pt-6 mb-6" data-id="element-190">
              <div className="flex items-center gap-2 mb-4" data-id="element-191">
                <Gift className="h-5 w-5 text-emerald-600" data-id="element-192" />
                <h4 className="font-bold text-gray-900" data-id="element-193">
                  + 3 Bonos incluidos GRATIS (valor $1.890 UYU)
                </h4>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-194">
                {bonusSummary.map((bonus, idx) => <div key={idx} className="bg-white rounded-lg border border-gray-200 overflow-hidden flex flex-col" data-id="element-195">
                    <div className="p-3 flex flex-col items-center text-center" data-id="element-196">
                      <img src={bonus.image} alt={bonus.title} className="w-full h-24 object-cover rounded-md mb-2" data-id="element-197" />
                      <p className="text-xs font-bold text-gray-900 mb-1" data-id="element-198">
                        {bonus.title}
                      </p>
                      <div className="flex items-center gap-1.5 mb-2" data-id="element-199">
                        <span className="text-xs text-gray-400 line-through" data-id="element-200">
                          {bonus.value}
                        </span>
                        <span className="text-xs font-bold text-emerald-700" data-id="element-201">
                          GRATIS
                        </span>
                      </div>
                      <button onClick={() => toggleBonus(idx)} className="flex items-center gap-1 text-emerald-700 hover:text-emerald-800 text-xs font-semibold transition-colors" data-id="element-202">
                        {expandedBonus === idx ? <>
                            Leer menos <ChevronUp className="h-3.5 w-3.5" data-id="element-203" />
                          </> : <>
                            Leer más <ChevronDown className="h-3.5 w-3.5" data-id="element-204" />
                          </>}
                      </button>
                    </div>
                    {expandedBonus === idx && <div className="border-t border-gray-100 bg-gray-50 p-3" data-id="element-205">
                        <p className="text-xs text-gray-700 leading-relaxed mb-2" data-id="element-206">
                          {bonus.description}
                        </p>
                        <div className="bg-emerald-50 text-emerald-800 p-2 rounded text-xs italic border-l-4 border-emerald-500" data-id="element-207">
                          "{bonus.quote}"
                        </div>
                      </div>}
                  </div>)}
              </div>
            </div>

            {/* Price & CTA */}
            <div className="border-t border-gray-200 pt-8" data-id="element-208">
              <CountdownTimer data-id="element-209" />

              <div className="flex items-center justify-center gap-2 bg-amber-50 border border-amber-300 rounded-xl p-3 mb-6" data-id="element-210">
                <Users className="h-5 w-5 text-amber-600 flex-shrink-0" data-id="element-211" />
                <p className="text-amber-800 font-bold text-sm md:text-base" data-id="element-212">
                  Últimos 3 cupos disponibles al precio de oferta
                </p>
              </div>

              {/* Dynamic price */}
              <div className="text-center mb-6" data-id="element-213">
                <p className="text-gray-500 line-through text-xl mb-1" data-id="element-214">
                  Precio Normal: $580 UYU
                </p>
                <div className="flex items-center justify-center gap-3 mb-1" data-id="element-215">
                  <span className="text-5xl md:text-6xl font-extrabold text-gray-900 transition-all duration-300" data-id="element-216">
                    ${totalPrice}
                  </span>
                  <span className="text-2xl font-bold text-gray-600" data-id="element-217">UYU</span>
                  {totalPrice === BASE_PRICE && <span className="bg-red-100 text-red-700 text-sm font-bold px-2 py-1 rounded-lg" data-id="element-218">
                      -50%
                    </span>}
                </div>
                <p className="text-emerald-700 font-semibold text-sm" data-id="element-219">
                  {totalPrice > BASE_PRICE ? `Protocolo $290 + extras seleccionados $${totalPrice - BASE_PRICE}` : 'Precio especial de lanzamiento'}
                </p>
              </div>

              <div className="flex items-center justify-center gap-2 mb-6 text-gray-600 text-sm" data-id="element-220">
                <Download className="h-4 w-4 text-emerald-600" data-id="element-221" />
                <span className="font-semibold text-emerald-700" data-id="element-222">
                  +1.400 descargas
                </span>
                <span className="text-gray-400" data-id="element-223">·</span>
                <span className="font-semibold" data-id="element-224">4.9/5 promedio</span>
              </div>

              {/* ORDER BUMPS — positioned before CTA for maximum visibility */}
              <div className="space-y-4 mb-6" data-id="element-225">
                {/* BUMP 1 — El Recetario de la Feria */}
                <div className={`bump-shimmer rounded-xl border-2 border-dashed transition-all duration-300 cursor-pointer ${bump1 ? 'border-orange-400 bg-orange-50 shadow-lg shadow-orange-100' : 'border-orange-300 bg-amber-50/50 hover:border-orange-400 hover:bg-orange-50/70'}`} onClick={() => setBump1(!bump1)} data-id="element-226">
                  <div className="bg-orange-500 text-white text-center py-1.5 px-3 text-xs font-bold uppercase tracking-wider flex items-center justify-center gap-1.5 rounded-t-[10px]" data-id="element-227">
                    <Star className="h-3.5 w-3.5 fill-current" data-id="element-228" />
                    Altamente Recomendado
                    <Star className="h-3.5 w-3.5 fill-current" data-id="element-229" />
                  </div>
                  <div className="p-4 md:p-5" data-id="element-230">
                    <div className="flex items-start gap-4" data-id="element-231">
                      <div className={`mt-1 w-6 h-6 rounded border-2 flex-shrink-0 flex items-center justify-center transition-all ${bump1 ? 'bg-orange-500 border-orange-500' : 'border-gray-300 bg-white'}`} data-id="element-232">
                        {bump1 && <Check className="h-4 w-4 text-white" data-id="element-233" />}
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-234">
                        <p className="font-bold text-gray-900 text-sm mb-2" data-id="element-235">
                          🍽️ ¡No pierda tiempo pensando qué cocinar! Sume el
                          Menú Completo de 7 Días por solo{' '}
                          <span className="text-orange-600" data-id="element-236">
                            ${BUMP1_PRICE} UYU
                          </span>
                        </p>
                        <div className="flex flex-col sm:flex-row gap-3" data-id="element-237">
                          <img src="https://cdn.magicpatterns.com/uploads/dr7pQu83eN59infjLTCt4j/Recetario_169.png" alt="El Recetario de la Feria" className="w-full sm:w-28 h-24 object-cover rounded-lg flex-shrink-0" data-id="element-238" />
                          <div className="flex-1" data-id="element-239">
                            <p className="font-bold text-orange-800 text-xs mb-1.5 flex items-center gap-1.5" data-id="element-240">
                              <UtensilsCrossed className="h-3.5 w-3.5" data-id="element-241" /> El
                              Recetario de la Feria — Menú de 7 Días
                            </p>
                            <p className="text-xs text-gray-600 leading-relaxed mb-2" data-id="element-242">
                              El mapa exacto de qué desayunar, almorzar y cenar
                              de lunes a domingo para que su azúcar no suba ni
                              un punto. Incluye el secreto del{' '}
                              <strong data-id="element-243">"Asado Glicémico"</strong> y recetas
                              rápidas de 10 minutos con lo que ya tiene en su
                              cocina.
                            </p>
                            <div className="flex items-center gap-2 mb-1" data-id="element-244">
                              <span className="text-xs text-gray-400 line-through" data-id="element-245">
                                $1.500 UYU
                              </span>
                              <span className="text-xs font-extrabold text-orange-600" data-id="element-246">
                                ${BUMP1_PRICE} UYU
                              </span>
                              <span className="bg-orange-100 text-orange-700 text-[10px] font-bold px-1.5 py-0.5 rounded" data-id="element-247">
                                -74%
                              </span>
                            </div>
                            <p className="text-[10px] text-gray-400 italic" data-id="element-248">
                              ¡Menos de lo que cuesta un postre en un
                              restaurante!
                            </p>
                          </div>
                        </div>
                        <div className="mt-2 flex items-center gap-2" data-id="element-249">
                          <div className={`text-xs font-bold px-3 py-1 rounded-full transition-all ${bump1 ? 'bg-orange-500 text-white' : 'bg-orange-100 text-orange-700'}`} data-id="element-250">
                            {bump1 ? '✓ Agregado a tu pedido' : 'Sí, quiero agregar el Recetario a mi pedido'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-orange-100 text-orange-700 text-center py-1 text-[10px] font-semibold rounded-b-[10px]" data-id="element-251">
                    ⚡ Oferta disponible solo en esta página
                  </div>
                </div>

                {/* BUMP 2 — La Polis del Páncreas */}
                <div className={`bump-shimmer rounded-xl border-2 border-dashed transition-all duration-300 cursor-pointer ${bump2 ? 'border-blue-400 bg-blue-50 shadow-lg shadow-blue-100' : 'border-blue-300 bg-sky-50/50 hover:border-blue-400 hover:bg-blue-50/70'}`} onClick={() => setBump2(!bump2)} data-id="element-252">
                  <div className="bg-blue-600 text-white text-center py-1.5 px-3 text-xs font-bold uppercase tracking-wider flex items-center justify-center gap-1.5 rounded-t-[10px]" data-id="element-253">
                    <Star className="h-3.5 w-3.5 fill-current" data-id="element-254" />
                    Altamente Recomendado
                    <Star className="h-3.5 w-3.5 fill-current" data-id="element-255" />
                  </div>
                  <div className="p-4 md:p-5" data-id="element-256">
                    <div className="flex items-start gap-4" data-id="element-257">
                      <div className={`mt-1 w-6 h-6 rounded border-2 flex-shrink-0 flex items-center justify-center transition-all ${bump2 ? 'bg-blue-500 border-blue-500' : 'border-gray-300 bg-white'}`} data-id="element-258">
                        {bump2 && <Check className="h-4 w-4 text-white" data-id="element-259" />}
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-260">
                        <p className="font-bold text-gray-900 text-sm mb-2" data-id="element-261">
                          📈 Tome el control total: Sume la Bitácora de
                          Resultados{' '}
                          <span className="text-blue-600" data-id="element-262">"La Polis"</span> por
                          solo{' '}
                          <span className="text-blue-600" data-id="element-263">
                            ${BUMP2_PRICE} UYU
                          </span>
                        </p>
                        <div className="flex flex-col sm:flex-row gap-3" data-id="element-264">
                          <img src="https://cdn.magicpatterns.com/uploads/4EBSQLZ9ZkWpyeBWxkuqPx/La_polis_169.png" alt="La Polis del Páncreas — Bitácora de Control" className="w-full sm:w-28 h-24 object-cover rounded-lg flex-shrink-0" data-id="element-265" />
                          <div className="flex-1" data-id="element-266">
                            <p className="font-bold text-blue-800 text-xs mb-1.5 flex items-center gap-1.5" data-id="element-267">
                              <BarChart3 className="h-3.5 w-3.5" data-id="element-268" /> La "Polis"
                              del Páncreas — Bitácora de Control
                            </p>
                            <p className="text-xs text-gray-600 leading-relaxed mb-2" data-id="element-269">
                              Lo que no se mide, no se mejora. Registre sus
                              niveles de ayunas, síntomas de hormigueo y energía
                              diaria. Vea cómo su curva de glucosa baja día a
                              día y{' '}
                              <strong data-id="element-270">
                                muéstrele sus progresos reales a su médico
                              </strong>{' '}
                              en la próxima consulta.
                            </p>
                            <div className="flex items-center gap-2 mb-1" data-id="element-271">
                              <span className="text-xs text-gray-400 line-through" data-id="element-272">
                                $1.500 UYU
                              </span>
                              <span className="text-xs font-extrabold text-blue-600" data-id="element-273">
                                ${BUMP2_PRICE} UYU
                              </span>
                              <span className="bg-blue-100 text-blue-700 text-[10px] font-bold px-1.5 py-0.5 rounded" data-id="element-274">
                                -74%
                              </span>
                            </div>
                            <p className="text-[10px] text-gray-400 italic" data-id="element-275">
                              ¡Garantice su éxito con datos reales!
                            </p>
                          </div>
                        </div>
                        <div className="mt-2 flex items-center gap-2" data-id="element-276">
                          <div className={`text-xs font-bold px-3 py-1 rounded-full transition-all ${bump2 ? 'bg-blue-500 text-white' : 'bg-blue-100 text-blue-700'}`} data-id="element-277">
                            {bump2 ? '✓ Agregado a tu pedido' : 'Sí, quiero agregar la Bitácora a mi pedido'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-blue-100 text-blue-700 text-center py-1 text-[10px] font-semibold rounded-b-[10px]" data-id="element-278">
                    ⚡ Oferta disponible solo en esta página
                  </div>
                </div>
              </div>

              {/* Guarantee */}
              <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 flex items-start gap-3 text-left mb-6" data-id="element-279">
                <ShieldCheck className="h-6 w-6 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-280" />
                <div data-id="element-281">
                  <p className="font-bold text-emerald-900 text-sm" data-id="element-282">
                    Garantía de 7 días
                  </p>
                  <p className="text-emerald-800 text-xs mt-1" data-id="element-283">
                    Si no ve resultados, le devolvemos cada peso. Sin preguntas.
                  </p>
                </div>
              </div>

              {/* VALUE SUMMARY TABLE */}
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden mb-6" data-id="element-284">
                <div className="px-5 py-3 bg-gray-50 border-b border-gray-200" data-id="element-285">
                  <p className="font-bold text-gray-900 text-sm text-center" data-id="element-286">
                    Resumen de tu pedido
                  </p>
                </div>
                <div className="divide-y divide-gray-100" data-id="element-287">
                  <div className="flex items-center justify-between px-5 py-3" data-id="element-288">
                    <span className="text-sm text-gray-800" data-id="element-289">
                      El Protocolo de Limpieza Glicémica
                    </span>
                    <span className="text-sm text-gray-400 line-through" data-id="element-290">
                      ${originalProtocol}.00
                    </span>
                  </div>
                  <div className="flex items-center justify-between px-5 py-3" data-id="element-291">
                    <span className="text-sm text-gray-800" data-id="element-292">
                      3 Bonos de Lanzamiento
                    </span>
                    <span className="text-sm text-gray-400 line-through" data-id="element-293">
                      ${originalBonuses}.00
                    </span>
                  </div>
                  {bump1 && <div className="flex items-center justify-between px-5 py-3 bg-orange-50" data-id="element-294">
                      <span className="text-sm text-gray-800 flex items-center gap-1.5" data-id="element-295">
                        <UtensilsCrossed className="h-3.5 w-3.5 text-orange-600" data-id="element-296" />
                        El Recetario de la Feria
                      </span>
                      <span className="text-sm text-gray-400 line-through" data-id="element-297">
                        ${originalBump1}.00
                      </span>
                    </div>}
                  {bump2 && <div className="flex items-center justify-between px-5 py-3 bg-blue-50" data-id="element-298">
                      <span className="text-sm text-gray-800 flex items-center gap-1.5" data-id="element-299">
                        <BarChart3 className="h-3.5 w-3.5 text-blue-600" data-id="element-300" />
                        La Polis del Páncreas
                      </span>
                      <span className="text-sm text-gray-400 line-through" data-id="element-301">
                        ${originalBump2}.00
                      </span>
                    </div>}
                </div>
                <div className="border-t-2 border-gray-200" data-id="element-302">
                  <div className="flex items-center justify-between px-5 py-3" data-id="element-303">
                    <span className="text-sm font-bold text-gray-900" data-id="element-304">
                      Valor Total
                    </span>
                    <span className="text-sm font-bold text-gray-400 line-through" data-id="element-305">
                      ${totalOriginal}.00
                    </span>
                  </div>
                  <div className="flex items-center justify-between px-5 py-4 bg-emerald-600 text-white" data-id="element-306">
                    <span className="font-extrabold text-base" data-id="element-307">
                      Hoy pagás solo
                    </span>
                    <span className="font-extrabold text-2xl transition-all duration-300" data-id="element-308">
                      ${totalPrice}.00
                    </span>
                  </div>
                </div>
              </div>

              {/* SECOND CTA BUTTON */}
              <Button size="lg" fullWidth onClick={handleCheckoutClick} className="max-w-md mx-auto mb-3 shadow-xl" data-id="element-309">
                <ShoppingCart className="mr-2 h-5 w-5" data-id="element-310" />
                Completar Compra — ${totalPrice} UYU
              </Button>
              <p className="text-center text-xs text-gray-500" data-id="element-311">
                Descarga inmediata. Sin esperas. Sin complicaciones.
              </p>
            </div>
          </div>
        </Card>
      </div>

      <ExitIntentPopup isOpen={showPopup} onClose={() => setShowPopup(false)} data-id="element-312" />
    </section>;
}